import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";
import isNil from "lodash/isNil";

import { api, contract } from "#app/http/api";
import { round } from "shared";

export type UpdateProcessStepRequestDto = ClientInferRequest<
  typeof contract.processSteps.update
>["body"];

export type UpdateProcessStepResponseDto = ClientInferResponseBody<
  typeof contract.processSteps.update
>;

export const updateProcessStep = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateProcessStepRequestDto;
}): Promise<UpdateProcessStepResponseDto | null> => {
  const response = await api.processSteps.update.mutation({
    params: { id },
    body: {
      ...payload,
      fixedCost: !isNil(payload.fixedCost) ? round(payload.fixedCost) : undefined,
      fixedCostPerSeries: !isNil(payload.fixedCostPerSeries)
        ? round(payload.fixedCostPerSeries)
        : undefined,
      machineHourlyPrice: !isNil(payload.machineHourlyPrice)
        ? round(payload.machineHourlyPrice)
        : undefined,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
